import { takeLatest, put, call } from "redux-saga/effects";
import {
    CHATGROUP_DATA, CHATGROUP_GET_API,
    GROUPMESSAGE_GET_DATA, GROUPMESSAGE_GET_DETAIL_API,
    GROUPMEMBER_DELETE_DATA, GROUPMEMBER_DELETE_API,
    GROUPMESSAGE_ADD_DATA,GROUPMESSAGE_POST_API,
    CHATMETRICS_DATA, CHATMETRICS_GET_API,
    USERMETRICS_DATA, USERMETRICS_GET_API,
    GROUPMEMBER_ADD_DATA,GROUPMEMBER_POST_API,  
    WVMETRICS_DATA,WVMETRICS_GET_API,
    CHAT_IMPORT_API,CHAT_IMPORT_DATA,
    CHAT_GROUPAUDIT_DATA,CHAT_GROUPAUDIT_API,
    CHAT_USERAUDIT_DATA, CHAT_USERAUDIT_API,
    
} from './Constants'
import {
    setChatGroupDataSuccess, setChatGroupDataFail,
    setGroupMemberDeleteDataFail,setGroupMemberDeleteDataSuccess,
    setGroupMessageGetDataSuccess,setGroupMessageGetDataFail,
    setGroupMessageAddDataSuccess, setGroupMessageAddDataFail,
    setChatMetricsDataSuccess,setChatMetricsDataFail,
    setUserMetricsDataSuccess, setUserMetricsDataFail,
    setGroupMemberAddDataSuccess,setGroupMemberAddDataFail,
    setWVMetricsDataFail,setWVMetricsDataSuccess,
    setChatImportDataFail,setChatImportDataSuccess,
    setChatGroupAuditDataFail, setChatGroupAuditDataSuccess,
    setChatUserAuditDataFail, setChatUserAuditDataSuccess,
   
} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../alert/Actions";
import { getRequest,getDetailRequest, postRequest, putRequest, deleteRequest, postImportRequest } from "../../../shared/components/Service";

function* getAllChatGroupDataService({ payload }) {
  try {
      const response = yield call(getRequest, `${CHATGROUP_GET_API}/${payload}`);
      if (response.status === 200) {
          yield put(setChatGroupDataSuccess(response.data));
      } else {
          yield put(addErrorAlert(response.response.data.msg));
          yield put(setChatGroupDataFail(response.response.data));
      }
  } catch (error) {
      yield put(addErrorAlert("Error retrieving ChatGroups"));
      yield put(setChatGroupDataFail(error));
  }
}
function* getUserMetricsDataService({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const getUserMetricsDataResponse = yield call(getRequest, `${USERMETRICS_GET_API}?${queryParams}`);
    const status = getUserMetricsDataResponse.status;
    if (status === 200) {
      const data = getUserMetricsDataResponse.data.data;
      yield put(setUserMetricsDataSuccess(data));
    } else {
      yield put(setChatMetricsDataFail(getUserMetricsDataResponse.response.data));
    }
  } catch (error) {
    yield put(setUserMetricsDataFail(error));
  }
}
function* getChatMetricsDataService({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const getChatMetricsDataResponse = yield call(getRequest, `${CHATMETRICS_GET_API}?${queryParams}`  );
    const status = getChatMetricsDataResponse.status;
    if (status === 200) {
      const data = getChatMetricsDataResponse.data.data;
      yield put(setChatMetricsDataSuccess(data));
    } else {
      yield put(setChatMetricsDataFail(getChatMetricsDataResponse.response.data));
    }
  } catch (error) {
    yield put(setChatMetricsDataFail(error));
  }
}

function* getWVMetricsDataService({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();    
    const getWVMetricsDataResponse = yield call(getRequest, `${WVMETRICS_GET_API}/${payload}`);
    const status = getWVMetricsDataResponse.status;
    if (status === 200) {
      const data = getWVMetricsDataResponse.data.data;
      yield put(setWVMetricsDataSuccess(data));
    } else {
      yield put(setWVMetricsDataFail(getWVMetricsDataResponse.response.data));
    }
  } catch (error) {
    yield put(setWVMetricsDataFail(error));
  }
} 

function* getGroupMessageDataService({ id }) {
  try {
    const getGroupMessageDataResponse = yield call(
      getDetailRequest,
      GROUPMESSAGE_GET_DETAIL_API + id
    );
    const status = getGroupMessageDataResponse.status;
    if (status === 200) {
      const data = getGroupMessageDataResponse.data;
      yield put(setGroupMessageGetDataSuccess(data));
    } else {
      yield put(setGroupMessageGetDataFail(getGroupMessageDataResponse.response.data));
    }
  } catch (error) {
    yield put(setGroupMessageGetDataFail(error));
  }
}
function* deleteGroupMemberDataService({ request }) {
    try {
      console.log("request in saga", request)
      const groupMemberDataResponse = yield call(
        postRequest,
        GROUPMEMBER_DELETE_API,
        request
      );
      const status = groupMemberDataResponse.status;
      if (status === 200) {
        const member = groupMemberDataResponse.data;
       // yield put(addSuccessAlert('Member Deleted'))
        yield put(setGroupMemberDeleteDataSuccess(member));
      } else {
        yield put(addErrorAlert(groupMemberDataResponse.response.data.msg))
        yield put(setGroupMemberDeleteDataFail(groupMemberDataResponse.response.data));
      }
    } catch (error) {
      yield put(addErrorAlert("Error deleting Member"))
      yield put(setGroupMemberDeleteDataFail(error));
    }
  }
  function* postGroupMessageDataService({ request }) {
    try {  
      console.log("request in saga", request)
      const GroupMessageDataResponse = yield call(
        postRequest,
        GROUPMESSAGE_POST_API,
        request
      );
      const status = GroupMessageDataResponse.status;
      if (status === 200) {
        const message = GroupMessageDataResponse;
        //yield put(addSuccessAlert('Message sent'))
        yield put(setGroupMessageAddDataSuccess(message.data.data));
      } else {
        yield put(addErrorAlert(GroupMessageDataResponse.response.data.msg))
        yield put(setGroupMessageAddDataFail(GroupMessageDataResponse.response.data));
      }
    } catch (error) {
      yield put(addErrorAlert("Error adding message"))
      yield put(setGroupMessageAddDataFail(error));
    }
  }
  function* postGroupMemberDataService({ request }) {
    try {  
      console.log("request in saga", request)
      const GroupMemberDataResponse = yield call(
        postRequest,
        GROUPMEMBER_POST_API,
        request
      );
      const status = GroupMemberDataResponse.status;
      if (status === 200) {
        const message = GroupMemberDataResponse;
       // yield put(addSuccessAlert('Member Added'))
        yield put(setGroupMemberAddDataSuccess(GroupMemberDataResponse.data));
      } else {
        yield put(addErrorAlert(GroupMemberDataResponse.response.data.msg))
        yield put(setGroupMessageAddDataFail(GroupMemberDataResponse.response.data));
      }
    } catch (error) {
      yield put(addErrorAlert("Error adding member"))
      yield put(setGroupMemberAddDataFail(error));
    }
  }
  function* postImportChatDataService({ request }) {
    try {
      const response = yield call(
        postImportRequest,
        CHAT_IMPORT_API,
        request
      );
      const status = response.status;
      if (status === 200) {
        const newData = response.data;
        yield put(addSuccessAlert("document sent"))
        yield put(setChatImportDataSuccess(newData));
      } else {
        yield put(addErrorAlert(response.response.data.msg))
        yield put(setChatImportDataFail(response.response.data));
      }
    } catch (error) {
      yield put(addErrorAlert('Could not sent document'))
      yield put(setChatImportDataFail(error));
    }
  }
  function* postChatGroupAuditDataService({ request }) {
    try {
      const response = yield call(
        postRequest,
        CHAT_GROUPAUDIT_API,
        request
      );
      const status = response.status;
      if (status === 200) {
        const newData = response.data;
        yield put(setChatGroupAuditDataSuccess(newData));
      } else {
        yield put(addErrorAlert(response.response.data.msg))
        yield put(setChatGroupAuditDataFail(response.response.data));
      }
    } catch (error) {
      yield put(setChatGroupAuditDataFail(error));
    }
  }
    function* postChatUserAuditDataService({ request }) {
        try {
          const response = yield call(
            postRequest,
            CHAT_USERAUDIT_API,
            request
          );
          const status = response.status;
          if (status === 200) {
            const newData = response.data;
            yield put(setChatUserAuditDataSuccess(newData));
          } else {
            yield put(addErrorAlert(response.response.data.msg))
            yield put(setChatUserAuditDataFail(response.response.data));
          }
        } catch (error) {
          yield put(setChatUserAuditDataFail(error));
        }
      }

export function* watchChatGroup(){
    yield takeLatest(CHATGROUP_DATA.CHATGROUP_DATA_LOAD, getAllChatGroupDataService);
    yield takeLatest(GROUPMEMBER_DELETE_DATA.GROUPMEMBER_DELETE_DATA_LOAD,deleteGroupMemberDataService );
    yield takeLatest(GROUPMESSAGE_GET_DATA.GROUPMESSAGE_GET_DATA_LOAD,getGroupMessageDataService); 
    yield takeLatest(GROUPMESSAGE_ADD_DATA.GROUPMESSAGE_ADD_DATA_LOAD, postGroupMessageDataService);
    yield takeLatest(CHATMETRICS_DATA.CHATMETRICS_DATA_LOAD, getChatMetricsDataService);
    yield takeLatest(USERMETRICS_DATA.USERMETRICS_DATA_LOAD, getUserMetricsDataService);
    yield takeLatest(GROUPMEMBER_ADD_DATA.GROUPMEMBER_ADD_DATA_LOAD, postGroupMemberDataService);
    yield takeLatest(WVMETRICS_DATA.WVMETRICS_DATA_LOAD, getWVMetricsDataService);
    yield takeLatest(CHAT_IMPORT_DATA.CHAT_IMPORT_DATA_LOAD, postImportChatDataService);
    yield takeLatest(CHAT_GROUPAUDIT_DATA.CHAT_GROUPAUDIT_DATA_LOAD, postChatGroupAuditDataService);
    yield takeLatest(CHAT_USERAUDIT_DATA.CHAT_USERAUDIT_DATA_LOAD, postChatUserAuditDataService);
    
}